export const SET_PAYMENT_PENDING_REQUEST = 'setPaymentPendingRequest'
export const SET_PAYMENT = 'setPayment'
export const SET_PAYMENT_MODES = 'setPaymentModes'
